<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <!-- Overlay di caricamento -->
    <CustomOverlay :show="overlay_show" text="Richiesta in corso, attendere...">

    <!-- Tutorial contestuale per gli argomenti del form. Vengono passati gli slug name dei video da mostrare -->
    <TutorialContestuale :video_to_show="['tutorial_rimborsi_spese']"/>

      <!-- CARD PRICIPALE DI CONTENIMENTO DI TUTTO IL FORM -->
      <b-card :title="form_name" class="mr-1 ml-1">

        <!-- MODALE CON INFO STATICHE PER L'UTENTE - SOSTITUISCE I BLOCCHI COLORATI IN CIMA AL FORM -->
        <b-modal ref="static-info-modal"
          title="Rimborso spese - Note per l'utente"
          no-close-on-esc
          no-close-on-backdrop
          hide-header-close
          size='xl'>
          <p class="text-justify">
            In quest'area puoi richiedere il rimborso delle spese che hai sostenuto per te o per conto dei tuoi familiari,
            come da <b>articolo 12 del TUIR</b>. Compila tutti i campi obbligatori del modulo ed allega i documenti
            giustificativi della spesa; provvederemo alla validazione del rimborso nei giorni lavorativi successivi
            all'inserimento della tua richiesta. L'importo ti verrà accreditato direttamente sulla busta paga del mese
            successivo a quello della validazione, compatibilmente con i tempi di elaborazione dei cedolini paga.
            <b>Ti ricordiamo che dovrà essere inserita una richiesta per ogni singolo familiare.</b>
          </p>
          <p class="text-justify">
            Se chiedi il rimborso per uno dei tuoi familiari, sarà necessario caricare anche la scansione dello stato
            di famiglia o un'autocertificazione. Puoi scaricare i modelli in bianco delle differenti
            autocertificazioni (carico fiscale, autocertificazione di parentela ecc.) nella sezione <b-link :to="{ 'name' : 'site-documentazione', 'params': { 'group_to_show' : 'rimb-spese' } }">Documentazione</b-link>.
          </p>
          <h5><b>Importante!</b></h5>
          <ul class="text-justify" >
            <li>Nel caso di rimborso spese per l'acquisto di testi scolastici è necessario allegare nella sezione “documentazione aggiuntiva” un'autocertificazione o un documento che indichi che i testi acquistati sono quelli abilitati dalla scuola o dall'università</li>
            <li>Per il rimborso delle spese assistenziali per familiari anziani/non autosufficienti è necessario allegare nella sezione “documentazione aggiuntiva” un documento che certifichi l'invalidità o la necessità di assistenza da parte dell'anziano o della persona non autosufficiente</li>
            <li>Per il rimborso delle spese per l'acquisto di abbonamenti per il trasporto pubblico è necessario allegare nella sezione “documentazione aggiuntiva” una copia fronte/retro del tesserino di abbonamento e, nella sezione “dati del beneficiario della prestazione”, un'autocertificazione oppure un documento che indichi che il famigliare per il quale si richiede il rimborso è a carico fiscale del beneficiario del piano welfare .</li>
            <li>Per il rimborso delle spese per trasporto casa-scuola è necessario allegare nella sezione “documentazione aggiuntiva” un documento che attesti l’indirizzo dell’istituto scolastico (ad esempio copia del certificato di frequenza scolastica)</li>
            <li>Per il rimborso delle per la retta univesitaria per il familiare a carico fiscale è necessario allegare nella sezione “dati del beneficiario della prestazione”, un'autocertificazione oppure un documento che indichi che il familiare per il quale si richiede il rimborso è a carico fiscale del beneficiario del piano welfare.</li>            
            <li>Per il rimborso delle spese quota retta asilo nido per le quali si riceve BONUS INPS è necessario allegare nella sezione “documentazione aggiuntiva” un documento certificativo della quota rimborsi INPS ricevuta</li>
          </ul>
          <template #modal-footer="{ cancel }">
            <b-button size="sm" variant="primary" @click="cancel()">
              Chiudi
            </b-button>
          </template>
        </b-modal>

        <b-form @submit.prevent="onSubmit">
          <!-- DATI DEL RIMBORSO SPESE -->
          <b-card title="Dati del rimborso" class="ml-1 mr-1 mt-2 mb-2">

            <!-- Oggetto del rimborso spese ( id categoria )-->
            <b-form-group id="group-oggetto"
              label="* Oggetto del rimborso:"
              label-for="oggetto"
            >
              <b-form-select id="oggetto"
                v-model="form.id_categ"
                :options="categorie_rimborso"
                required></b-form-select>
            </b-form-group>

            <!-- Importo del rimborso -->
            <b-form-group id="group-importo"
              label="* Importo da rimborsare:"
              label-for="importo"
              :invalidFeedback="importo_help_text"
              description="Indicare gli importi in Euro (iva inclusa)">
              <b-input-group prepend="€">
                <b-form-input
                  id="importo"
                  v-model="form.importo"
                  @keyup="check_importo"
                  :state="importo_state"
                  required
                ></b-form-input>
              </b-input-group>
            </b-form-group>

            <!-- Modale per caricamento doc di pagamento -->
            <b-form-group id="group-file-doc-pagamento"
                label="* Documento di pagamento:">
                <template #description>
                  <p class='text-justify'>
                    ATTENZIONE: Si intende solo ed esclusivamente il giustificativo di pagamento ed è fondamentale
                    che la data inserita sia quella in cui il pagamento è fisicamente stato effettuato
                  </p>
                </template>

              <FileUploadModal :file_kind="file_upload_modals.file_doc_pagamento.file_kind"
                               :add_button_text="'Carica il file'"
                               :remove_button_text="'Rimuovi il file'"
                               :doc_date_text="'* Data di esecuzione del pagamento:'"
                               :exclude_file_options="[31]"
                               @fileIdReady="assegna_id_file"
                               @fileRemoved="rimuovi_id_file"/>
            </b-form-group>

            <!-- Modale per caricamento doc di acquisto -->
            <b-form-group id="group-file-doc-acquisto"
                label="* Documento d'acquisto:">
              <FileUploadModal :file_kind="file_upload_modals.file_doc_acquisto.file_kind"
                               :add_button_text="'Carica il file'"
                               :remove_button_text="'Rimuovi il file'"
                               :exclude_file_options="[27,29,30]"
                               @fileIdReady="assegna_id_file"
                               @fileRemoved="rimuovi_id_file"/>
            </b-form-group>

            <!-- Modale per caricamento della doc aggiuntiva -->
            <b-form-group id="group-file-doc-aggiuntiva"
                label="Documentazione aggiuntiva:">
              <FileUploadModal :file_kind="file_upload_modals.file_doc_aggiuntiva.file_kind"
                               :add_button_text="'Allega documentazione aggiuntiva'"
                               :remove_button_text="'Rimuovi la documentazione'"
                               :exclude_file_options="[28]"
                               @fileIdReady="assegna_id_file"
                               @fileRemoved="rimuovi_id_file"/>
            </b-form-group>
          </b-card>

          <!-- DATI DEL BENEFICIARIO - SOLO SE NECESSARIO, POTREBBE ANCHE ESSERE PER SE STESSI -->
          <!-- Tramite la prop "me_stesso" dico al form se visualizzare anche l'opzione per se stessi -->
          <!-- la visualizzazione è basata sul servizio scelto ( id_categ ) -->
          <b-card title="Dati del beneficiario della prestazione" class="ml-1 mr-1 mt-2 mb-2">
            <FormBeneficiario :me_stesso="me_stesso[ form.id_categ ]"
                              :preset_beneficiario="preset_beneficiario"
                              @benDataChanged="dati_beneficiario = $event"></FormBeneficiario>
          </b-card>

          <!-- Pulsante di invio -->
          <b-button type="submit" variant="primary" class="mr-1">Invia richiesta</b-button>


        </b-form>
      </b-card>
    </CustomOverlay>
  </div>
</template>


<script>
import PageTagline from '@/components/PageTagline'
import CustomOverlay from '@/components/CustomOverlay'
import TutorialContestuale from '@/components/TutorialContestuale'
import FileUploadModal from '@/components/FileUploadModal'
import FormBeneficiario from '@/components/FormBeneficiario'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'RimborsoSpese',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "Rimborso Spese", link : 'rimb-spese' } ],
      form_name : "Rimborso spese",
      form_kind : 1, // il kind del rimborso spese
      overlay_show: false, // overlay con spinner per indicare che il sistema sta lavorando

      // Categorie di rimborso selezionabili
      categorie_rimborso : [
        { value: null, text: "Seleziona un'opzione", disabled: true }
      ],

      // Oggetto interno che dice se il rimborso può essere fatto solo per un
      // familiare od anche per se stessi.
      me_stesso : {},

      // Dati del form
      form : {
        id_categ : null,
        importo : null,
        // Array con gli id dei files da associare all'acquisto
        docs : []
      },

      // Stato dell'importo per visualizzare se stiamo sforando il credito
      importo_state : null,

      // Dati per inizilizzare le modali di caricamento files ed ospitare i dati di
      // ritorno da esse.
      file_upload_modals : {
        file_doc_pagamento : { file_kind : 'doc_pagam', doc_id : null },
        file_doc_acquisto: { file_kind: 'doc_acq', doc_id : null },
        file_doc_aggiuntiva : { file_kind: 'doc_extra', doc_id : null }
      },

      // Dati del beneficiario
      dati_beneficiario : null,

      // Se stiamo operando in modalità replay, mettiamo in questa variabile
      // i dati per valorizzare il form del beneficiario
      preset_beneficiario : null

    }
  },
  computed : {
    /**
     * Visualizza un avviso per l'utente se dalla validazione della casella
     * dell'importo si evince che sta sforando il suo credito welfare.
     */
    importo_help_text : function () {
      if ( this.importo_state === false ) {
        let credito = this.$store.state.user.user_credito.totale;
        let mess = "Attenzione, l'importo immesso supera il tuo attuale credito welfare che è di " +
                    credito + " euro. Non sarai in grado di completare la richiesta."
        return mess;
      } else {
        return '';
      }
    }
  },
  methods : {
    /**
     * Esecuzione dell'acquisto
     */
    onSubmit : function () {

      let data_to_send = {};

      // Verifico innanzi tutto che ci siano tutti i files richiesti e compilo
      // l'array dei files da associare all'acquisto.
      if ( ! this.compila_array_docs() ) {
        return;
      }

      // Dati del beneficiario, se il beneficiario non è me_stesso controllo la presenza
      // dei dati e se sono tutti li unisco ai dati da inviare
      if ( this.dati_beneficiario.me_stesso === false && ( this.dati_beneficiario.cod_fisc_ben === null ||
           this.dati_beneficiario.nome_ben === null || this.dati_beneficiario.id_relazione_ben === null ) ) {
        generalLib.backend_error_message_box( this, "I dati del benificiario non risultano completi, verificare e riprovare." );
        return;
      } else {
        data_to_send[ 'me_stesso' ] = this.dati_beneficiario.me_stesso;
        data_to_send[ 'cod_fisc_ben' ] = this.dati_beneficiario.cod_fisc_ben;
        data_to_send[ 'nome_ben' ] = this.dati_beneficiario.nome_ben;
        data_to_send[ 'id_relazione_ben' ] = this.dati_beneficiario.id_relazione_ben;
      }

      // Siamo pronti per inviare i dati di acquisto, unisco anche i dati del rimborso e ci siamo!
      Object.assign( data_to_send, this.form );

      generalLib.acquisto_confirm_message_box (  this, this.form.importo, 'totale' )
      .then( ( value ) => {
        // L'utente ha risposto Annulla.
        if ( !value ) return;

        // Se invece l'utente decide di proseguire attivo
        // l'overlay e poi eseguo il post delle info.
        this.overlay_show = true;

        axios.post( apiUrl.welfareapi.create_acq_rimbspese , data_to_send )
        .then( (response) => {

          // Visualizza la finestra di completamento, la quale alla chiusura ci riporta
          // alla home.
          generalLib.acquisto_complete_message_box( this, response.data.id_acquisto )
          .then ( ( val ) => {
              this.$router.push( { name : 'menu'} );
          });

        })
        .catch( (error) => {
            this.overlay_show = false;
            generalLib.backend_error_message_box( this, error.response.data );
        });

      })
      .catch( ( error ) => {
        console.error( error );
      });

    },
    /**
     * Controlliamo che l'importo in euro sia nel formato corretto,
     * altrimenti rimuoviamo l'ultimo carattere scritto dall'utente.
     */
    check_importo : function () {
      if ( !generalLib.euro_is_valid( this.form.importo ) ){
        this.form.importo = this.form.importo.slice(0,this.form.importo.length - 1);
      }
    },

    /**
     * Verifica la presenza dei files che sono richiesti e compila l'array docs con
     * gli id degli stessi.
     * Torna true se tutti i files che devono essere presenti ci sono altrimenti torna
     * false.
     */
    compila_array_docs : function () {

      // Puliamo prima l'array
      this.form.docs = new Array();

      // Il file del documento di pagamento è richiesto
      if ( this.file_upload_modals.file_doc_pagamento.doc_id === null ) {
        generalLib.backend_error_message_box( this, "E' necessario caricare il file relativo al documento di pagamento per proseguire" );
        return false;
      }
      this.form.docs.push( this.file_upload_modals.file_doc_pagamento.doc_id );

      // Il file del documento di acquisto è richiesto
      if ( this.file_upload_modals.file_doc_acquisto.doc_id === null ) {
        generalLib.backend_error_message_box( this, "E' necessario caricare il file relativo al documento di acquisto per proseguire" );
        return false;
      }
      this.form.docs.push( this.file_upload_modals.file_doc_acquisto.doc_id );

      // Il file dello stato di famiglia è richiesto se non sono io il beneficiario
      // va quindi inserito in array solo se il flag me_stesso è false
      if ( this.dati_beneficiario.me_stesso === false &&  this.dati_beneficiario.doc_id === null ){
        generalLib.backend_error_message_box( this, "E' necessario caricare la documentazione richiesta per il beneficiario." );
        return false;
      }
      if ( this.dati_beneficiario.me_stesso === false ){
        this.form.docs.push( this.dati_beneficiario.doc_id );
      }

      // Il file della documetnazione aggiuntiva non è obbligatorio lo aggiugiamo se presente
      if ( this.file_upload_modals.file_doc_aggiuntiva.doc_id !== null ) {
        this.form.docs.push( this.file_upload_modals.file_doc_aggiuntiva.doc_id );
      }

      return true;

    },
    /**
     * Chiamata quando le modali di upload dei files restituiscono dati,
     * assegna all'oggetto interno dedicato ai files i valori tornati.
     */
    assegna_id_file : function ( data ) {
      if ( data.file_kind === 'doc_pagam' ) {
        this.file_upload_modals.file_doc_pagamento.doc_id = data.doc_id;
      }
      if ( data.file_kind === 'doc_acq' ) {
        this.file_upload_modals.file_doc_acquisto.doc_id = data.doc_id;
      }
      if ( data.file_kind === 'doc_extra' ) {
        this.file_upload_modals.file_doc_aggiuntiva.doc_id = data.doc_id;
      }
    },
    /**
     * Chiamata quando le modali di upload dei files tolgono via i documenti
     * rimuove gli id dall'oggetto interno del form.
     */
    rimuovi_id_file : function ( data ) {
      if ( data.file_kind === 'doc_pagam' ) {
        this.file_upload_modals.file_doc_pagamento.doc_id = null;
      }
      if ( data.file_kind === 'doc_acq' ) {
        this.file_upload_modals.file_doc_acquisto.doc_id = null;
      }
      if ( data.file_kind === 'doc_extra' ) {
        this.file_upload_modals.file_doc_aggiuntiva.doc_id = null;
      }
    },
    /**
     * Se stiamo operando in versione replay ( la prop id_acq_replay è settata ), va
     * a prendere i dati da usare per questo nuovo acquisto da un acquisto passato il cui
     * id viene passato dal router e posto per l'appunto nella prop id_acq_replay.
     */
    get_replay_data : function () {

      if ( this.id_acq_replay === null ) return;

      let api_url = apiUrl.welfareapi.acq_info_full.replace( '@id_acquisto', this.id_acq_replay );

      axios.get( api_url )
      .then( (response) => {

        // Se per qualche motivo l'acquisto non ha il kind giusto, non possiamo popolare il form.
        if ( response.data.kind != this.form_kind ) return;

        this.form.id_categ = response.data.id_categ_id;
        this.form.importo = response.data.acquisto_row.importo_totale;

        // Se il beneficiario è diverso da null, cioè non sono io stesso
        // il beneficiario dell'acquisto, allora devo preparare il giusto
        // oggettod a passare alla property preset_beneficiario del componente
        // FormBeneficiario, vedi la documentazione della prop per info
        // sull'oggetto da passare.
        let preset_beneficiario = null;

        if ( response.data.beneficiario != null ) {
          let nome_beneficiario = response.data.beneficiario.nome;
          if ( response.data.beneficiario.cognome != null ) {
            nome_beneficiario += ' ' + response.data.beneficiario.cognome;
          }
          preset_beneficiario = { id_relazione_parentale : response.data.relazione_parentale.id,
                                  nome : nome_beneficiario,
                                  cod_fisc : response.data.beneficiario.cod_fisc  }
        }

        this.preset_beneficiario = preset_beneficiario;

      })
      .catch( (error) => {
        generalLib.backend_error_message_box( this, error.response.data );
      })
    }
  },
  watch : {
    /**
     * Verifica in tempo reale se l'importo immesso supera l'attuale disponibilià
     * welfare dell'utente, se sfora segna lo stato dell'importo a false colorando
     * di rosso la casella di input.
     */
    'form.importo' : function ( val ) {
      let importo = parseFloat( val );
      if ( importo > this.$store.state.user.user_credito.totale ){
        this.importo_state = false;
      } else {
        this.importo_state = null;
      }
    }
  },
  /**
   * Alla creazione del componente prendiamo dal backend i nomi e gli id delle possibile categorie
   * di acquisto. Andiamo anche a valorizzare l'oggetto interno "me_stesso" che ci dice se il beneficiario
   * della prestazione può essere solo un familiare o possiamo anche essere noi stessi.
   * Se siamo in modalità replay ( è stata passata la prop id_acq_replay con l'id dell'acquisto ) allora
   * il form viene popolato con tutti i dati che è possibile caricare.
   */
  created : function () {
    let api_url = apiUrl.welfareapi.acq_categ_kind.replace( '@kind', this.form_kind );
    axios.get( api_url )
      .then( (response) => {
        for ( let elem of response.data ) {
          this.categorie_rimborso.push( { value : elem.id, text : elem.nome } );
          this.me_stesso[ elem.id ] = elem.me_stesso;
        }
        // Se siamo in modalità replay prendiamo i dati per il form.
        this.get_replay_data();
    })
    .catch( (error) => {
        let mess = "Si è verificato un errore nel caricamento delle categorie di rimborso, " +
                   "non sarà possibile concludere correttamente la procedura. " +
                   "Tornare alla homepage e riprovare ad aprire il form. Se il problema persiste " +
                   "contattare l'assistenza."
        generalLib.backend_error_message_box( this, mess );
     })
  },
  /**
   * Quando la pagina è pronta visualizziamo la modale informativa per il servizio.
   */
  mounted : function () {
    this.$refs['static-info-modal'].show();
  },
  props : {
    /**
    * Prop che è passata dal router, se valorizzata indica l'acquisto da replicare
    * inserendo per l'utente i dati nel form.
    */
    id_acq_replay: {
      type: [String, Number],
      default : null
    }
  },
  components: {
    PageTagline,
    CustomOverlay,
    TutorialContestuale,
    FileUploadModal,
    FormBeneficiario
  }
}
</script>


<style scoped>
/* Vedi il form della previdenza integrativa per la spiegazione di questo
   workaround*/
#group-importo :deep( .invalid-feedback ) {
  display: block;
}
</style>